<template>
  <modal @close-modal="close">
    <div class="initiate-reset-password">
      <h2 class="my-0">Reset Your Password</h2>
      <h4
        v-if="user.userEmail != null && user.userEmail != ''"
        class="font-weight-normal my-1"
      >
        Are you sure to send a password recovery email to {{ user.userEmail }}?
      </h4>
      <h4 v-else class="font-weight-normal my-1">
        You do not have an email associated with this account. Please add one
        and try again.
      </h4>
      <div class="justify-content-center mt-4">
        <button
          :disabled="
            loadingBTNChange || user.userEmail == null || user.userEmail == ''
          "
          @click="initiateResetPassword"
        >
          <b v-if="!loadingBTNChange">Send Reset Password Email</b>
          <div v-else class="row justify-content-center align-items-center">
            <Spinner style="margin: 0 !important" />
          </div>
        </button>
      </div>
    </div>
  </modal>
</template>

<script setup>
// core
import { ref } from 'vue';
import { useAPI } from '@/composables/useAPI';
import { useUserStore } from '@/stores/user';
import { emitter } from '@/core/emitter';

// components
import Modal from '@/components/global/Modal.vue';
import Spinner from '@/components/global/Spinner.vue';

// Reset password
const { user } = useUserStore();
const loadingBTNChange = ref(false);
const { request } = useAPI('/user/sendPasswordRevokeEmail');

const emit = defineEmits(['closeModal']);
function close() {
  emit('closeModal');
}

async function initiateResetPassword() {
  loadingBTNChange.value = true;
  try {
    await request({ email: user.userEmail });
    emitter.emit('showAlert', {
      shown: true,
      type: 'email-success',
      status: 'ok',
      title: 'Success!',
      detail: 'Please check your email for your password reset link.',
    });
  } catch {
    emitter.emit('showAlert', {
      shown: true,
      type: 'email-fail',
      status: 'danger',
      title: 'Error! This Email Is Not Registered',
      detail: 'Please enter the email associated with this account',
    });
  } finally {
    loadingBTNChange.value = false;
    emit('closeModal');
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/variables.scss';
@import '@/scss/theme/variables.scss';

.form-details {
  color: $grey-2400;
  font-size: $font-size-sm;

  &.error {
    color: $red-400;
  }
  &.success {
    color: $green-500;
  }
}
.initiate-reset-password {
  max-width: 450px;
  background: $grey-500;
  padding: 1rem 2rem;
  color: $grey-2400;

  &-header {
    border-bottom: 1px solid $color-primary;
  }
}
h2 {
  color: $color-primary_01;
}
h4 {
  margin: 0;
  font-size: $font-size-base;
  color: $blue-1100;
}
h5 {
  color: $grey-2600;
}
p {
  margin: 0;
}
input {
  width: 100%;
  font-size: 16px;
}
button {
  padding: 1rem;
  width: 100%;
}
</style>
